import { setNonce } from 'get-nonce';
import { nanoid } from 'nanoid';

export const nonceId = nanoid();

// Set Nonce using a library that is used by peer packages (react-style-singleton for example)
// @doc https://github.com/theKashey/get-nonce
setNonce(nonceId);
